import { styled } from '@abyss/web/tools/styled';
import { Flex } from '@abyss/web/ui/Flex';
import { V2ModalDialog } from '@abyss/web/ui/ModalDialog';
import { Text } from '@abyss/web/ui/Text';

export const LocationModal = styled(V2ModalDialog, {
  '.abyss-modal-base-header-container': {
    padding: '16px',
  },
  '.abyss-modal-base-body': {
    rowGap: '8px',
  },
});

export const MessagingText = styled(Text, {
  '&.abyss-text-root': {
    maxWidth: '940px',
    textAlign: 'center',
    fontStyle: 'normal',
    fontWeight: '400',
  },
});

export const LocationInputContainer = styled(Flex, {
  flexWrap: 'nowrap',
  height: '71px',
  backgroundColor: '#FFFFFF',
  borderRight: 'solid',
  borderLeft: 'solid',
  borderTop: 'solid',
  borderBottom: 'solid',
  borderColor: '#CBCCCD',
  borderRadius: '50px',
  paddingRight: '20px',
  paddingLeft: '20px',
  justifyContent: 'space-between',
  minWidth: '420px',
  width: '66%',
  '@screen < $md': {
    width: '80%',
    minWidth: '320px',
  },
  '@screen < $sm': {
    width: '100%',
    minWidth: '100px',
    paddingRight: '10px',
    paddingLeft: '10px',
    '.abyss-search-input-root': {
      minWidth: '150px',
    },
    button: {
      padding: '10px 16px',
    },
  },
  '.abyss-search-input-root': {
    height: '38px',
  },
  '.abyss-search-input-input': {
    height: '38px',
    background: 'transparent',
    paddingRight: '35px',
  },
  '#location-search-input-area': {
    flexGrow: 1,
    marginRight: '5px',
  },

  variants: {
    isLocationModal: {
      true: {
        maxWidth: '408px',
        minWidth: 'auto',
        paddingRight: '0px',
        height: '58px',
        // marginTop: '8px',
        '.abyss-search-input-input': {
          height: '24px',
          minHeight: '24px',
        },
      },
    },
    isLocationModalInFocus: {
      true: {
        borderColor: '$interactive1',
        borderBottom: '0px',
        borderTopLeftRadius: '32px',
        borderTopRightRadius: '32px',
        borderBottomLeftRadius: '0px',
        borderBottomRightRadius: '0px',
      },
    },
  },
});
